import { searchEcFormBuilderController } from '../../controller/searchEcFormBuilderController';

export default function fbRegisterDirective() {
  return {
    restrict: 'A',
    scope: false,
    priority: 10001,
    require: '^^?ecFormBuilder',
    compile: () => ({ pre: link }),
  };

  // ///////////////////////////////////////////////////////////////////////////

  function link(scope, element, attrs, ecFormBuilderController) {
    try {
      ecFormBuilderController = ecFormBuilderController || searchEcFormBuilderController(scope);
      ecFormBuilderController.bind(scope, attrs.fbRegister);
    } catch (e) {
      console.error('fbRegister', e, element[0]);
      return;
    }
  }
}
